import DOMPurify from 'dompurify';

/**
 * Sanitizes html text by stripping disallowed markup.
 *
 * @param {string} message Raw message content, possibly containing HTML.
 * @returns {string} Safe HTML string limited to the allowed tags/attributes.
 */
export function sanitizeText(text) {
    if (!text) return '';
    return DOMPurify.sanitize(text, {
        ALLOWED_TAGS: ['strong', 'em', 'b', 'i', 'u', 'br', 'p', 'span'],
        ALLOWED_ATTR: [],
    });
}
